/**
 * 库存管理
 */
import { INVENTORYMANAGE } from '../types';

export default {
    name: `${INVENTORYMANAGE}`,
    path: '/inventoryManage',
    component: () => import(/* webpackChunkName: 'inventoryManage' */ '@/views/inventoryManage/'),
    redirect: { name: `${INVENTORYMANAGE}Index` },
    meta: {
        title: '库存管理',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${INVENTORYMANAGE}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'inventoryManage' */ '@/views/inventoryManage/home/Home.vue'),
        },

        // 二级页面示例, 没有二级页面就直接删掉
        // {
        //     name: `${INVENTORYMANAGE}Detail`,
        //     path: 'detail',
        //     component: () => import(/* webpackChunkName: 'inventoryManage' */ '@/views/inventoryManage/detail/Detail.vue'),
        // },
    ],
};
